module.exports = __webpack_public_path__ + "static/images/hb2.610c01f.jpg";